import * as React from "react";
function SvgIcInfoCircleFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.292 4a8.292 8.292 0 108.291 8.292A8.301 8.301 0 0012.293 4zm-.573 5.977h1.24v7.26h-1.24v-7.26zm.334-2.604a.693.693 0 01.296-.043.705.705 0 01.55.208c.126.14.193.322.188.51a.672.672 0 01-.738.705.704.704 0 01-.547-.202.715.715 0 01-.184-.503.74.74 0 01.184-.51.692.692 0 01.25-.165z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcInfoCircleFilled;
